import { EpisodeContextType } from "@/containers/Episode/context";
import { MentionCardContextType } from "@/containers/MentionCard/context";

export const extractMentionTrackingPayload = (
  mention: Pick<EpisodeContextType, "audio_url" | "share_url">
) => {
  return { url: mention.share_url, source: mention.audio_url };
};

export const extractMentionCardTrackingPayload = (
  mention: Pick<MentionCardContextType, "audioMentions" | "share_url">
) => {
  return {
    url: mention.share_url,
    source: mention.audioMentions[0]?.audio_url,
  };
};
